import { FC, ReactElement, useEffect, useState } from 'react'
import styled from 'styled-components'
import { SwissMap } from '../SwissMap'
import rawData from 'Assets/tarife_dummy.json'
import ColorLegend from 'components/ColorLegend'
import { ToolTipProps } from 'Types/toolTipProps'
import { ArrowIcon } from 'components/Icons/ArrowIcon'

// 🛑 TO DO REMOVE THIS WHEN WE HAVE THE NEW DATA
// removing the municipalities with value lower than 0
const rawDataFiltered = rawData.filter(
  (item) => item?.tarif_min_new && item.tarif_min_new > 0
)

type MuniDataType = {
  bfsId: number
  tarif_min_old?: number | null
  anbieter_cheapest_old?: string | null
  // Tooltip_old: string
  // n_old: number
  tarif_min_new?: number | null
  anbieter_cheapest_new: string
  // Tooltip_new: string
  // n_new: number
  problem: string
  diff_abs?: number | null
  diff_rel?: number | null
  GDENAME_de: string
  GDENAME_fr: string
  Kanton: string
  rang_tarif?: number | null
  rang_anstieg?: number | null
  json_string_new?: {name: string, value: number }[]
}
const muniData: MuniDataType[] = rawData.map((entry: MuniDataType) => {
  if (entry.tarif_min_new && entry.tarif_min_new > 0) {
    return entry
  } else {
    entry.tarif_min_new = undefined
    return entry
  }
})
const FloatingDiv = styled.div`
  margin: 0 auto;
  padding: 1rem;
  background-color: var(--tooltip-background-color);
  border-radius: 3px;
  font-size: 14px;
  font-family: var(--font-plex);
  min-width: 250px;
  max-width: 400px;
  box-shadow: 0 30px 60px rgb(0 0 0 / 8%);
  animation: slide-in-top 0.3s ease-in-out;
  margin-bottom: 2em;
  @keyframes slide-in-top {
    0% {
      transform: translate3d(0,-50px, 0);
      opacity: 0;
      max-height: 0;
    }
    100% {
      transform: translate3d(0,0,0);
      opacity: 1;
      max-height: 400px;
    }
  }
  h4 {
    margin: 0;
    display: flex;
    justify-content: space-between;
    font-size: 1.25em;
    margin-bottom: 0.3em;
    font-weight: 700;
    text-align: left;

  }
  table {
    /* th{
    border-bottom: 1px solid rgba(128, 128, 128, 0.1);
    } */
    width: 100%;
    
    .bold {
      font-weight: bold;
    }
    .provider{
      font-size: 0.9em;
      line-height: 1.5em;
    }
    .price{
      font-weight: bold;
      white-space: nowrap;
      text-align: right;
    }
  }
  .rank {
    margin-top: 0.75em;
    padding-top: 0.6em;
    color: var(--text-color);
    text-align: center;
    font-size: 0.85em;
    font-weight: 600;
    text-transform: uppercase;
  }
`
const RelChange = styled.div<{ change: number }>`
  display: flex;
  /* justify-content: flex-end; */
  align-items: center;
  flex-direction: row;
  color: ${(props) =>
    props.change > 0
      ? 'var(--change-color-red)'
      : props.change < 0
      ? 'var(--change-color-green)'
      : 'currentColor'};
  .arrow-icon {
    transition: all 500ms cubic-bezier(0.77, 0, 0.175, 1);
    width: 1em;
    height: 1em;
    margin-right: 0.5em;
  }
`
const colorPalette: [string, string, string] = [
  '#F8DEC6',
  '#F1BE8D',
  '#9E272F',
]
const ToolTip: React.FC<ToolTipProps> = ({
  activeData = {
    GDENAME_de: 'Keine Daten',
  },
  locale = 'de',
}): ReactElement => {
  return (
    <FloatingDiv>
      {activeData && (
        <>
          <table>
            { 
            <thead>
              <tr>
                <th colSpan={2}>   <h4>
                {
                  activeData[
                    ('GDENAME_' + locale) as 'GDENAME_de' | 'GDENAME_fr'
                  ] ?? (locale === 'fr' ? 'pas de données' : 'keine Daten')
                }
                <RelChange change={activeData.diff_rel}>
               { !isNaN(activeData.diff_rel) && activeData.diff_rel !== null && activeData.problem !== "TRUE" &&
                 (  <>
                  <ArrowIcon
                    rotation={
                      activeData.diff_rel > 0.5
                        ? -90
                        : activeData.diff_rel > 0
                        ? -45
                        : activeData.diff_rel < -0.5
                        ? 90
                        : activeData.diff_rel < 0
                        ? 45
                        : 0
                    }
                  />
                  {(activeData.diff_rel > 0 ? '+' : '') +
                    (activeData.diff_rel * 100).toFixed(1).replace(".",",") +
                    '%'}
                    </>)
                  }
                </RelChange>
              </h4></th>
              </tr>
            </thead>
            }
            <tbody>
              {activeData?.json_string_new?.map((provider:{name: string, value: number | null}, index:number) =>{
                return (
                  <tr key={provider.name + activeData.bfsId + index}>
                    <td className='provider'>{provider.name}</td>
                    <td className='price'>{provider.value ? provider.value.toFixed(1).replace(".",",") : '-'} {locale ==="fr" ? "ct/kWh": " Rp./KWh"}</td>
                  </tr>
                )
              })
              }
            </tbody>
          </table>
        </>
      )}
    </FloatingDiv>
  )
}
interface MapProps {
  colorMode?: 'dark' | 'light'
  bfsIdChangedEventName?: string
  bfsIdParamName?: string
  locale: 'de' | 'fr'
}

const Map: FC<MapProps> = ({
  colorMode,
  bfsIdChangedEventName = 'changeGDE',
  bfsIdParamName = 'gemeinde',
  locale = 'de',
}): ReactElement => {
  const [minValue, setMinValue] = useState<number>(15)
  const [maxValue, setMaxValue] = useState<number>(35)
  const [activeMunicipality, setActiveMunicipality] = useState<MuniDataType>()
  useEffect(() => {
    // getting the highest and lowest value of the tarif_max field

    // setMaxValue(
    //   Math.max.apply(
    //     0,
    //     rawDataFiltered.map((data) => {
    //       return data.tarif_min_new || 0
    //     })
    //   )
    // )
    // setMinValue(
    //   Math.min.apply(
    //     0,
    //     rawDataFiltered.map((data) => {
    //       return data.tarif_min_new || 1000
    //     })
    //   )
    // )
    // Get params from URL and set active municipality
    const searchParams = new URL(String(window.location)).searchParams
    const muniParam = searchParams.get(bfsIdParamName)
    const bfsIdFromUrl = muniParam && parseInt(muniParam)
    if (bfsIdFromUrl) {
      const foundMuni = muniData.find((data) => data.bfsId === bfsIdFromUrl)
      foundMuni?.['tarif_min_new'] && setActiveMunicipality(foundMuni)
    }

    // Add eventListener on the window to the bfsIdChanged event
    function handleBfsIdChanged(event: CustomEvent) {
      const foundMuni = muniData.find((data) => data.bfsId === event.detail)
      foundMuni && setActiveMunicipality(foundMuni)
    }
    window.addEventListener(
      bfsIdChangedEventName,
      handleBfsIdChanged as EventListener
    )
    return () => {
      window.removeEventListener(
        bfsIdChangedEventName,
        handleBfsIdChanged as EventListener
      )
    }
  }, [])

  return (
    <MapContainer>
      <SwissMap
        municipalityData={rawDataFiltered}
        propertyNameToCompare={'tarif_min_new'}
        minValue={minValue}
        maxValue={maxValue}
        topoJsonYear={2022}
        ToolTip={ToolTip}
        colorPalette={colorPalette}
        newActiveMunicipalityIdHandler={(newBfsId) =>
          setActiveMunicipality(
            muniData.find((data) => data.bfsId === newBfsId)
          )
        }
        activeMunicipalityId={activeMunicipality?.bfsId}
        zoomIntoActiveMunicipality={true}
        lakeFillColor={colorMode === 'dark' ? '#0e1e25' : undefined}
        locale={locale}
        // activeStrokeWidth={'3'}
        // hoverStrokeWidth={'.5'}
      />
      <ColorLegend
        colorPalette={colorPalette}
        minVal={minValue}
        maxVal={maxValue}
        currentValue={
          activeMunicipality?.tarif_min_new &&
          activeMunicipality?.tarif_min_new > 0
            ? activeMunicipality?.tarif_min_new
            : undefined
        }
        currentValueLabel={locale === "fr" ? ' ct/kWh'  : ' Rp./KWh'}

      />
      {activeMunicipality && activeMunicipality.tarif_min_new && (
        <ToolTip locale={locale} activeData={activeMunicipality}></ToolTip>
      )}
    </MapContainer>
  )
}
const MapContainer = styled.div`
  font-family: var(--font-noto);
  font-size: 1.8rem;
  line-height: 3rem;
  #swiss-choropleth-map {
    // min height on mobile
    @media (max-width: 768px) {
      min-height: 284px;
    }
    // min height on desktop
    @media (min-width: 768px) {
      min-height: 523px;
    }
    svg {
      min-width: 100%;
      max-height: 500px;
    }
  }
  .tick-label:first-child::before{
    content: '<';
  }
  .tick-label:last-child::before{
    content: '>';
  }
  /* .municipality-search,
  .ui.label,
  #search {
    font-size: 18px;
  }
  .results {
    grid-template-columns: repeat(auto-fill, minmax(23.4rem, 1fr));
    
  }
  .result {
    font-family: var(--font-plex);
    color: var(--text-color) !important;
  }
  .municipality-search {
    width: 100%;
    margin-bottom: 1rem;
    @media screen and (min-width: 600px) {
      max-width: 20em;
    }

    .input {
      width: 100%;
    }
  } */
`

export default Map
